"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUseAPIFrontend = exports.setHeaders = exports.setServerUrl = exports.getAPIFrontend = void 0;
const react_1 = require("react");
const client_1 = require("./client");
var client_2 = require("./client");
Object.defineProperty(exports, "getAPIFrontend", { enumerable: true, get: function () { return client_2.getAPIFrontend; } });
Object.defineProperty(exports, "setServerUrl", { enumerable: true, get: function () { return client_2.setServerUrl; } });
Object.defineProperty(exports, "setHeaders", { enumerable: true, get: function () { return client_2.setHeaders; } });
function getUseAPIFrontend() {
    const api = (0, client_1.getAPIFrontend)();
    return new Proxy({}, {
        get: (_, endpoint) => {
            return (params) => {
                const [reloadVariable, setReloadVariable] = (0, react_1.useState)(0);
                const reload = (0, react_1.useMemo)(() => () => {
                    setReloadVariable(v => v + 1);
                }, []);
                const refMounted = (0, react_1.useRef)(false);
                (0, react_1.useEffect)(() => {
                    refMounted.current = true;
                    return () => {
                        refMounted.current = false;
                    };
                }, []);
                const [result, setResult] = (0, react_1.useState)([null, null, true, 0, reload]);
                const refLast = (0, react_1.useRef)({});
                (0, react_1.useEffect)(() => {
                    const last = refLast.current = {};
                    setResult([null, null, true, 0, reload]);
                    api[endpoint](params).then((result) => {
                        if (refMounted.current && last === refLast.current)
                            setResult([result[0], result[1], false, result[2], reload]);
                    });
                    // eslint-disable-next-line react-hooks/exhaustive-deps
                }, [JSON.stringify(params), reloadVariable]);
                return result;
            };
        },
    });
}
exports.getUseAPIFrontend = getUseAPIFrontend;
